import React from "react";
import _ from "lodash";
import { MessageDescriptor } from "react-intl";

import { Select, SelectProps } from "@ui/Select";
import { withPlaylistsMap, InjectedPlaylistsMapProps } from "@vendor/components/withPlaylistsMap";
import { Playlist } from "../../models";

type Props = InjectedPlaylistsMapProps;

interface OuterProps {
    selected: number | number[];
    multiple?: boolean;
    placeholder?: string;
    placeholderMessage?: MessageDescriptor;
    onChange?: (id: number | number[]) => void;
}

type SelectPlaylist = typeof Select<Playlist>;
const SelectPlaylist = Select as SelectPlaylist;

class PlaylistSelect extends React.Component<Props & OuterProps> {
    private handleChange(option: Playlist | Playlist[]) {
        const { onChange } = this.props;
        if (this.props.onChange != null) {
            if (Array.isArray(option)) {
                onChange(_.map(option, (type) => type.id));
            }
            else if (option != null) {
                onChange(option.id);
            }
            else {
                onChange(null);
            }
        }
    }

    public render() {
        const {
            playlistsMap,
            selected,
            multiple,
            placeholder,
            placeholderMessage,
        } = this.props;

        // Get the value
        let playlistsArr: Playlist[] = [];
        _.forOwn(playlistsMap, (item) => {
            playlistsArr = playlistsArr.concat(item.playlists);
        });
        let value: Playlist[] = [];
        if (Array.isArray(selected)) {
            value = _.map(selected, (id) => _.find(playlistsArr, ["id", id]));
        }
        else {
            value = [_.find(playlistsArr, ["id", selected])];
        }

        // Setup the grouped options
        const options = _.values(playlistsMap).map((item) => ({
            label: item.vendorName,
            options: item.playlists,
        }));

        const props: SelectProps<Playlist> = {
            getOptionValue: (playlist) => String(playlist.id),
            getOptionLabel: (playlist) => playlist.name,
            isMulti: multiple != null && multiple === true,
            value,
            options,
            onChange: this.handleChange.bind(this),
        };
        if (placeholder != null) {
            props.placeholder = placeholder;
        }
        if (placeholderMessage != null) {
            props.placeholderMessage = placeholderMessage;
        }
        return (
            <div className="playlist-select">
                <SelectPlaylist {...props}/>
            </div>
        );
    }
}

const ConnectedPlaylistSelect = withPlaylistsMap(PlaylistSelect);

export {
    PlaylistSelect as PlaylistSelectPresenter,
    ConnectedPlaylistSelect as PlaylistSelect,
};
